import styled from 'styled-components'
import { media } from '~/components/GlobalStyle'

type IGrid = {
  display?: 'grid' | 'inline-grid'
  direction?: string
  columns?: string
  rows?: string
  gap?: string
  placeitems?: string
  columnsmobile?: string
  scroll?: string
}

/** For reference on values for grid visit this guid: https://css-tricks.com/snippets/css/complete-guide-grid/ */
export const Grid = styled.div<IGrid>`
  display: ${(props) => (props.display ? props.display : 'grid')};
  grid-template-columns: ${(props) =>
    props.columnsmobile ? props.columnsmobile : 'initial'};
  grid-gap: ${(props) => (props.gap ? props.gap : 'initial')};
  place-items: ${(props) => (props.placeitems ? props.placeitems : 'initial')};
  overflow: ${(props) => (props.scroll ? props.scroll : 'auto')};

  ${media.medium} {
    grid-template-columns: ${(props) =>
      props.columns ? props.columns : 'initial'};
    grid-template-rows: ${(props) => (props.rows ? props.rows : 'initial')};
  }
`
